import { useEffect, useState } from 'react';
import * as reportApi from '../api/PomReport';
import { IPomReportCategoryData, IPomReportCategorySumItem, IPomReportDataCategory, IPomReportDataInfo } from '../util/DataModelInterface'
import { Spinner } from '../components/Spinner';
// import { ToastWrap } from '../components/ToastWrap';
import { PomList } from '../components/PomList';
import { getCurrentPeriodString, getStartOfYearPeriodString } from '../util/FormatDateUtil';
import { useLocation, useNavigate } from 'react-router-dom';
import { DateSelector } from '../components/DateSelector';
import { FormattedMessage } from 'react-intl';
import useToastHandler from '../hooks/useToastHandler';

export const ReportAdminCompany = () => {

  const { state } = useLocation();
  const navigate = useNavigate();
  const [companyId, ] = useState(state.companyId);
  const [companyName, ] = useState(state.companyName);
  const { addToast } = useToastHandler();

  // console.log("STATE", state);

  const [categories, setCategories] = useState([] as IPomReportCategoryData[]);
  const [reportData, setReportData] = useState({} as IPomReportDataCategory);
  const [reportInfoData, setReportInfoData] = useState({} as IPomReportDataInfo);
  const [reportCatSumData, setReportCatSumData] = useState({} as {[x: string]: IPomReportCategorySumItem});
  const [loading, setLoading] = useState(false);
  const [startPeriod, setStartPeriod] = useState(getStartOfYearPeriodString());
  const [endPeriod, setEndPeriod] = useState(getCurrentPeriodString());

  const [errorText, setErrorText] = useState("");

  useEffect(() => {
      setErrorText("");

      const fetchDataAsync = async () => {
          try {
              setLoading(true);
              const data1 = await reportApi.getReports(startPeriod, endPeriod, companyId);
              // console.log("Pom report[" + startPeriod + " - " + endPeriod + "] - data: " + JSON.stringify(data1));
              // console.log("Pom report[" + startPeriod + " - " + endPeriod + "]");
              if (data1?.result) {
                  setReportData(data1.result.categories);
                  setReportInfoData(data1.result.info);
                  setReportCatSumData(data1.result.catSums);
              }
              else if (data1?.error) {
                addToast(data1.error, 'reports', 'fetch');
                setErrorText(data1.error.value);
            }
              // setToastActive(false);

              if (!categories.length) {
                const data2 = await reportApi.getCategories();
                // console.log("Pom categories - data", data2);
                if (data2?.error) {
                  addToast(data2.error, 'reports', 'fetch');
                  setErrorText(data2.error.value);
                } else if (data2) {
                    setCategories(data2);
                }
              }
              setLoading(false);
          } catch (error) {
              return error;
          }
        }
      fetchDataAsync();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startPeriod, endPeriod]);


  return (
      <>
      <Spinner active={loading} />
      {/* <ToastWrap active={toastActive} heading={toastHeader} text={toastText} type={toastType} setActive={(active: boolean) => setToastActive(active)} /> */}
      { !errorText &&
      <>
          <div className="action-buttons py-4 d-flex flex-row align-items-start">
            <div className="page-header">
              <h1>{companyName}</h1>
              <p className="info"><i className="fa fa-info-circle me-2"></i>SE-laitteiden maahantuontimäärien raportointi</p>
            </div>
            <div className="ms-auto d-flex flex-row align-items-center">
              <button type="button" className="btn btn-secondary" onClick={() => { navigate(-1); }}>
                <i className="fa fa-close me-2"></i>
                <FormattedMessage id="button.close"/>
              </button>
            </div>
          </div>
          <DateSelector
            startPeriod={startPeriod}
            endPeriod={endPeriod}
            isStartAndEnd={true}
            onChange={(start, end) => { setStartPeriod(start); setEndPeriod(end);}}
            showMonth={true}
            dateFormat='MM/yyyy'
            inputFormat='yyyy-MM'/>
            { categories && categories.length > 0 &&
                <PomList
                  categories={categories}
                  reportData={reportData}
                  reportInfoData={reportInfoData}
                  reportCatSumData={reportCatSumData}
                  period={startPeriod}
                  companyName={companyName}
                  periodEnd={endPeriod}
                />
            }
      </>
      }
      { errorText &&
          <div id="reportinfo">
              {errorText}
          </div> }
      </>
  );
};